import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import WorkshopDetailHeader from '../../../components/MyPage/WorkshopManagement/WorkshopDetailHeader';
import WorkshopDetailSummary from '../../../components/MyPage/WorkshopManagement/WorkshopDetailSummary';
import WorkshopDetailList from '../../../components/MyPage/WorkshopManagement/WorkshopDetailList';

const WorkshopManagementDetail = () => {
  const navigate = useNavigate();
  const [detail, setDetail] = useState(null);
  const [selectedSlotId, setSelectedSlotId] = useState(null);
  const [selectedBookingIds, setSelectedBookingIds] = useState(new Set());

  const handleStatsUpdate = (updater) => {
    setDetail((prev) => {
      if (!prev) return prev;
      const newStats = updater(prev.stats);
      return { ...prev, stats: newStats };
    });
  };

  const handleDelete = () => {
    navigate('/mypage?tab=Workshop%20Management', {
      state: { showToast: true },
    });
  };

  return (
    <div className='flex flex-col items-center bg-grayscale-gray01 w-full min-h-[1006px] pt-[60px] px-[80px] pb-[500px]'>
      <div className='flex flex-col min-w-[1000px] max-w-[1462px] items-start w-full'>
        <WorkshopDetailHeader
          onSlotSelect={setSelectedSlotId}
          selectedSlotId={selectedSlotId}
          selectedBookingIds={selectedBookingIds}
          onDeleteSuccess={handleDelete}
        />
        <WorkshopDetailSummary
          slotId={selectedSlotId}
          onDetailLoaded={setDetail}
          stats={detail?.stats}
        />
        <WorkshopDetailList
          confirmedList={detail?.confirmedList ?? []}
          waitlistedList={detail?.waitlistedList ?? []}
          canceledList={detail?.canceledList ?? []}
          blockedList={detail?.blockedList ?? []}
          onStatsUpdate={handleStatsUpdate}
          selectedBookingIds={selectedBookingIds}
          setSelectedBookingIds={setSelectedBookingIds}
          slotId={selectedSlotId}
        />
      </div>
    </div>
  );
};

export default WorkshopManagementDetail;
